var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Container, ContainerDisplays, ContainerFlexAlignItems, ContainerFlexDirections, ContainerFlexGaps, ContainerFlexWraps } from '../../../../templates/container';
import { Text, TextHtmlTags, TextVariants } from '../../../../atoms/text';
import { ThemeUtils } from '../../../../../utils';
var PI = function (_a) {
    var props = __rest(_a, []);
    var reverse = props.reverse, currentPriceTextProps = props.currentPriceTextProps, originalPriceTextProps = props.originalPriceTextProps, message = props.message;
    var containerConfig = {
        display: ContainerDisplays.Flex,
        flexDirection: reverse
            ? ContainerFlexDirections.RowReverse
            : ContainerFlexDirections.Row,
        flexGap: ThemeUtils.getResponsiveProp([
            { x: ContainerFlexGaps.Size_2, y: ContainerFlexGaps.Size_3 }
        ]),
        flexAlignItems: ContainerFlexAlignItems.Center,
        flexWrap: ContainerFlexWraps.Wrap
    };
    var currentPriceTextConfig = __assign({ variant: TextVariants.H5, component: TextHtmlTags.Span }, currentPriceTextProps);
    var originalPriceTextConfig = __assign({ isHtml: true, variant: TextVariants.H6, component: TextHtmlTags.Del }, originalPriceTextProps);
    var messageTextConfig = {
        content: message,
        variant: TextVariants.Body3
    };
    return (React.createElement(Container, __assign({}, containerConfig),
        currentPriceTextProps && React.createElement(Text, __assign({}, currentPriceTextConfig)),
        originalPriceTextProps && React.createElement(Text, __assign({}, originalPriceTextConfig)),
        message && React.createElement(Text, __assign({}, messageTextConfig))));
};
export { PI as PriceInfo };
